"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { style: { "max-height": "50vh", "overflow": "auto" } };
const _hoisted_2 = {
    key: 0,
    style: { "display": "flex", "align-items": "center" }
};
const _hoisted_3 = { class: "the-note" };
const _hoisted_4 = {
    key: 1,
    style: { "display": "flex", "align-items": "center" }
};
const _hoisted_5 = { class: "the-note" };
const _hoisted_6 = {
    key: 2,
    style: { "position": "absolute", "left": "3rem", "top": "1rem", "background": "#0ff8", "width": "fit-content", "border-radius": "0.5rem", "align-self": "center", "height": "2rem", "padding": "0 1rem", "pointer-events": "none", "display": "flex", "align-items": "center", "justify-content": "center" }
};
const _hoisted_7 = { style: { "position": "absolute", "right": "1rem", "top": "1rem" } };
const _hoisted_8 = ["src", "title"];
const _hoisted_9 = {
    key: 0,
    style: { "background": "#0ff8", "width": "fit-content", "border-radius": "0.5rem", "align-self": "center", "height": "2rem", "padding": "0 1rem", "pointer-events": "none", "display": "flex", "align-items": "center", "justify-content": "center" }
};
const _hoisted_10 = { class: "the-top-right-buttons the-navigation-buttons" };
const _hoisted_11 = { class: "the-navigation-button" };
const _hoisted_12 = { style: { "position": "absolute", "right": "1rem", "top": "5rem" } };
const _hoisted_13 = ["src", "title"];
const vue_3 = require("vue");
const map_config_1 = __importDefault(require("~/config/map.config"));
const vue_map_sdk_1 = require("@xenodrive/vue-map-sdk");
require("@xenodrive/vue-basic-ui/styles/basic.css");
const BssMapVehicleInfobox_vue_1 = __importDefault(require("@/components/BssMapVehicleInfobox.vue"));
const LoadPage_vue_1 = __importDefault(require("@/components/LoadPage.vue"));
const ModalCreate_vue_1 = __importDefault(require("@/components/ModalCreate.vue"));
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
const BssMovementToggleListButton_vue_1 = __importDefault(require("@/components/BssMovementToggleListButton.vue"));
const BssMovementLayoutChanger_vue_1 = __importDefault(require("@/components/BssMovementLayoutChanger.vue"));
const BssMovementNaviationIcons_vue_1 = __importDefault(require("@/components/BssMovementNaviationIcons.vue"));
const BssMovementConfig_vue_1 = __importDefault(require("@/components/BssMovementConfig.vue"));
const BssMapDestinationInfobox_vue_1 = __importDefault(require("../components/BssMapDestinationInfobox.vue"));
const minimatch_1 = require("minimatch");
const utils_1 = require("@/utils");
exports.default = (0, vue_1.defineComponent)({
    __name: 'MapMovement',
    props: {
        url: {}
    },
    setup(__props, { expose: __expose }) {
        var _a, _b;
        const conditions = (0, vue_3.inject)('conditions');
        const props = __props;
        function onload() {
            window.initialize();
            window.$('body').trigger('bss:onload');
        }
        const query = (0, vue_3.computed)(() => {
            const search = new URLSearchParams(location.search);
            return '?' + search.toString();
        });
        const messages = (0, vue_3.reactive)({});
        const settings = (0, vue_3.reactive)({});
        const mapPinned = (0, vue_3.ref)(Boolean((_a = conditions === null || conditions === void 0 ? void 0 : conditions.map_position_is_fixed) !== null && _a !== void 0 ? _a : 1));
        const mapCenter = (0, vue_3.ref)([137.333872222, 38.0849725]);
        const mapSubCenter = (0, vue_3.ref)([137.333872222, 38.0849725]);
        const mapZoom = (0, vue_3.ref)(0);
        const mapSubZoom = (0, vue_3.ref)(4.5);
        if ((conditions === null || conditions === void 0 ? void 0 : conditions.map_position_is_fixed) &&
            conditions.map_position_lon &&
            conditions.map_position_lat &&
            conditions.map_position_zoom != null) {
            mapCenter.value = [conditions.map_position_lon, conditions.map_position_lat];
            mapZoom.value = conditions.map_position_zoom;
        }
        function saveMapPosition() {
            const v = mapPinned.value;
            (0, utils_1.save)('/movement/map_position/save', {
                map_position_is_fixed: v ? 1 : 0,
                map_position_lat: v ? mapCenter.value[1] : null,
                map_position_lon: v ? mapCenter.value[0] : null,
                map_position_zoom: v ? mapZoom.value : null,
            });
        }
        (0, vue_3.watch)(mapPinned, () => saveMapPosition());
        (0, vue_3.watch)([mapCenter, mapZoom], () => {
            if (!mapPinned.value)
                return;
            saveMapPosition();
        });
        const layout = (0, vue_3.ref)((_b = conditions === null || conditions === void 0 ? void 0 : conditions.layout_type) !== null && _b !== void 0 ? _b : 2);
        (0, vue_3.watch)(layout, (v) => {
            clearTrackingMode();
            (0, utils_1.save)('/movement/layout_type/save', { layout_type: v });
        });
        const showMenu = (0, vue_3.ref)(true);
        const mode = (0, vue_3.ref)('movement_map');
        (0, vue_3.watch)(mode, () => {
            const url = new URL(location.href);
            url.searchParams.set('mode', mode.value);
            location.href = url.toString();
        });
        const mapData = (0, vue_3.ref)({
            vehicles: [],
            destinations: [],
            movement_settings: {},
            section_id: null,
        });
        function vehicleId(id) {
            return `vehicle:${id}`;
        }
        function destinationId(id) {
            return `destination:${id}`;
        }
        const vehicles = (0, vue_3.computed)(() => {
            return Object.fromEntries(mapData.value.vehicles
                .filter((v) => v.vehicle_status != 99 || showEnded.value)
                .map((v) => [vehicleId(v.record_id), translateToMarker(v)]));
        });
        const destinations = (0, vue_3.computed)(() => Object.fromEntries(mapData.value.destinations.map((v) => [
            `destination:${v.id}`,
            {
                id: `destination:${v.id}`,
                coordinate: map_config_1.default.fromTokyo([Number(v.longitude), Number(v.latitude)]),
                icon: [
                    'icon_destination_1',
                    'icon_destination_2',
                    'icon_destination_3',
                    'icon_destination_4',
                    'icon_destination_5',
                ][v.destination_type - 1],
                direction: 0,
                data: v,
            },
        ])));
        const markers = (0, vue_3.computed)(() => (Object.assign(Object.assign({}, vehiclesFiltered.value), destinationsFiltered.value)));
        const popups = (0, vue_3.ref)([]);
        const trackingVehicleId = (0, vue_3.ref)(undefined);
        const vehiclesFilterIds = (0, vue_3.ref)(undefined);
        const vehiclesFiltered = (0, vue_3.computed)(() => !vehiclesFilterIds.value
            ? vehicles.value
            : Object.fromEntries(vehiclesFilterIds.value.map((id) => [id, vehicles.value[id]])));
        function clearTrackingMode() {
            setTrackingMode(null);
            // リスト上のボタン解除
            if (window.$('input.tracking-vehicle-button.active').length > 0) {
                window.$('input.tracking-vehicle-button').removeClass('active');
            }
            // 通知
            window.$('#map').trigger('mapMovement:onclickTrackingResetButton');
        }
        const destinationsFilterIds = (0, vue_3.ref)(undefined);
        const destinationsFiltered = (0, vue_3.computed)(() => !destinationsFilterIds.value
            ? destinations.value
            : Object.fromEntries(destinationsFilterIds.value.map((id) => [id, destinations.value[id]])));
        const showCluster = (0, vue_3.ref)(true);
        const showLabels = (0, vue_3.ref)(true);
        const showEnded = (0, vue_3.ref)(true);
        const vehicleAnnotations = (0, vue_3.computed)(() => [
            ...(showLabels.value
                ? [
                    { textKey: 'l_vehicle_name', offset: [24, -12], textAlign: 'left', ringColor: '#ff8' },
                    { textKey: 'l_driver_name', offset: [24, 0], textAlign: 'left', ringColor: '#ff8' },
                    { textKey: 'l_section_name', offset: [24, 12], textAlign: 'left', ringColor: '#ff8' },
                ]
                : []),
        ]);
        function translateToMarker(v) {
            var _a, _b;
            /* eslint-disable */
            const { n, direction } = {
                NONE: { n: '', direction: 0 },
                N: { n: '_n', direction: 0 },
                NE: { n: '_n', direction: 45 },
                E: { n: '_n', direction: 90 },
                SE: { n: '_n', direction: 135 },
                S: { n: '_n', direction: 180 },
                SW: { n: '_n', direction: 225 },
                W: { n: '_n', direction: 270 },
                NW: { n: '_n', direction: 315 },
            }[v.direction];
            const iconDefs = {
                '1:1': { icon: `icon_vehicle_1_1${n}`, direction }, // 走行中:実車
                '1:2': { icon: `icon_vehicle_1_2${n}`, direction }, // 走行中:空車
                '2:*': { icon: 'icon_vehicle_2' }, // 荷積中
                '3:*': { icon: 'icon_vehicle_3' }, // 荷卸中
                '4:*': { icon: 'icon_vehicle_4' }, // 待機
                '5:*': { icon: 'icon_vehicle_5' }, // 休憩
                '6:*': { icon: 'icon_vehicle_6' }, // フェリー
                '9:*': { icon: 'icon_vehicle_9' }, // その他
                '11:*': { icon: 'icon_vehicle_11' }, // 積置
                '12:*': { icon: 'icon_vehicle_12' }, // 予冷
                '2111:*': { icon: 'icon_vehicle_2111' }, // 温度異常・積置
                '2112:*': { icon: 'icon_vehicle_2112' }, // 温度異常・予冷
                '21:1': { icon: `icon_vehicle_21_1${n}`, direction }, // 温度異常:実車
                '21:2': { icon: `icon_vehicle_21_2${n}`, direction }, // 温度異常:空車
                '31:1': { icon: `icon_vehicle_31_1${n}`, direction }, // 遅延:実車
                '31:2': { icon: `icon_vehicle_31_2${n}`, direction }, // 遅延:空車
                '2131:1': { icon: `icon_vehicle_2131_1${n}`, direction }, // 温度異常・遅延:実車
                '2131:2': { icon: `icon_vehicle_2131_2${n}`, direction }, // 温度異常・遅延:空車
                '88:1': { icon: 'icon_vehicle_88_1' }, // 停車中:実車
                '88:2': { icon: 'icon_vehicle_88_2' }, // 停車中:空車
                '89:1': { icon: 'icon_vehicle_89_1' }, // 温度異常・停車中:実車
                '89:2': { icon: 'icon_vehicle_89_2' }, // 温度異常・停車中:空車
                '99:*': { icon: 'icon_vehicle_99' }, // 終了
                'NONE': { icon: 'icon_vehicle_999' }, // not found
            };
            /* eslint-enable */
            const key = (_a = Object.keys(iconDefs).find((k) => (0, minimatch_1.minimatch)(`${v.vehicle_status}:${v.luggage_status}`, k))) !== null && _a !== void 0 ? _a : 'NONE';
            const def = iconDefs[key];
            return {
                id: vehicleId(v.record_id),
                coordinate: [Number(v.longitude_w), Number(v.latitude_w)],
                icon: def.icon,
                direction: (_b = def.direction) !== null && _b !== void 0 ? _b : 0,
                data: Object.assign(Object.assign({}, v), { l_vehicle_name: labelStringIfVisible(v, 'vehicle_name'), l_driver_name: labelStringIfVisible(v, 'driver_name'), l_section_name: labelStringIfVisible(v, 'section_name') }),
            };
        }
        function labelStringIfVisible(v, key) {
            const category_key = 'v_infolabel_settings';
            const section_id = v.section_id || '';
            return window.checkMovementSetting(section_id, category_key, key, mapData.value.movement_settings)
                ? v[key]
                : '';
        }
        function closePopup(id) {
            if (!id)
                return;
            const idx = popups.value.indexOf(id);
            if (idx >= 0)
                popups.value.splice(idx, 1);
        }
        function openPopup(marker) {
            var _a;
            if (!marker)
                return;
            const key = (_a = marker === null || marker === void 0 ? void 0 : marker.id) !== null && _a !== void 0 ? _a : 'none';
            closePopup(key);
            popups.value.push(key);
            mapCenter.value = (0, vue_map_sdk_1.parseLngLat)(marker.coordinate).toCoordinate();
        }
        function togglePopup(marker) {
            var _a;
            if (!marker)
                return;
            const key = (_a = marker === null || marker === void 0 ? void 0 : marker.id) !== null && _a !== void 0 ? _a : 'none';
            if (popups.value.includes(key))
                closePopup(key);
            else
                openPopup(marker);
        }
        const clusterMarkers = (0, vue_3.ref)([]);
        const clusterPopupAnchor = (0, vue_3.ref)(undefined);
        const clusterPopup = (0, vue_3.ref)(false);
        function onClusterClicked(e) {
            if (e.markers && e.markers.length > 0) {
                clusterMarkers.value = e.markers;
                clusterPopupAnchor.value = [e.clientX, e.clientY];
                clusterPopup.value = true;
            }
        }
        function onMarkerClicked(e) {
            if (e.markers && e.markers.length === 1) {
                togglePopup(e.markers[0]);
                return;
            }
            onClusterClicked(e);
        }
        const map = (0, vue_3.useTemplateRef)('map');
        function setMapData(data, trackingId, mapPositionParam) {
            /*
            // dummy data test
            const vehicle_statuses: number[] = [1, 2, 3, 4, 5, 6, 9, 11, 12, 2111, 2112, 21, 31, 2131, 88, 89, 99];
            for (let i = 0; i < 5000; i++) {
                data.vehicles.push({
                    record_id: 'random:' + i,
                    direction: (['NONE', 'N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'] as const)[
                        Math.floor(Math.random() * 9) as number
                    ],
        
                    longitude_w: String(Math.random() * 14 - 5 + 135),
                    latitude_w: String(Math.random() * 15 - 5 + 35),
        
                    vehicle_id: 'random:' + i,
                    vehicle_name: 'random:' + i,
                    vehicle_code: 'random:' + i,
        
                    vehicle_status: vehicle_statuses[Math.floor(Math.random() * vehicle_statuses.length)],
                    luggage_status: Math.floor(Math.random() + 1),
        
                    ope_status: 0,
        
                    time: Date.now(),
                });
            }
            /*
             */
            mapData.value = data;
            if (mapPositionParam) {
                if ((mapPositionParam === null || mapPositionParam === void 0 ? void 0 : mapPositionParam.is_fixed) && Number(mapPositionParam.lon) > 0 && Number(mapPositionParam.lat) > 0) {
                    mapCenter.value = (0, vue_map_sdk_1.parseLngLat)([Number(mapPositionParam.lon), Number(mapPositionParam.lat)]).toCoordinate();
                    mapZoom.value = Number(mapPositionParam.zoom);
                }
                else if (mapData.value.vehicles.length > 0) {
                    const extent = mapData.value.vehicles.reduce((acc, val) => [
                        Math.min(+val.longitude_w, acc[0]),
                        Math.min(+val.latitude_w, acc[1]),
                        Math.max(+val.longitude_w, acc[2]),
                        Math.max(+val.latitude_w, acc[3]),
                    ], [180, 90, -180, -90]);
                    setTimeout(() => { var _a; return (_a = map.value) === null || _a === void 0 ? void 0 : _a.api.fitToExtent(extent); }, 100);
                    ;
                }
            }
            setTrackingMode(trackingId);
        }
        const trackingVehicle = (0, vue_3.computed)(() => (trackingVehicleId.value && vehiclesFiltered.value[trackingVehicleId.value]) || undefined);
        function setTrackingMode(trackingId) {
            var _a, _b;
            if (trackingId) {
                trackingVehicleId.value = vehicleId(trackingId);
                if (layout.value === 1) {
                    mapSubCenter.value = (0, vue_map_sdk_1.parseLngLat)((_a = trackingVehicle.value) === null || _a === void 0 ? void 0 : _a.coordinate).toCoordinate();
                    mapSubZoom.value = 15;
                }
                else {
                    mapCenter.value = (0, vue_map_sdk_1.parseLngLat)((_b = trackingVehicle.value) === null || _b === void 0 ? void 0 : _b.coordinate).toCoordinate();
                    if (mapZoom.value < 15)
                        mapZoom.value = 15;
                }
            }
            else {
                trackingVehicleId.value = undefined;
                mapSubCenter.value = [137.333872222, 38.0849725];
                mapSubZoom.value = 4.5;
            }
        }
        (0, vue_3.provide)('messages', messages);
        __expose({
            init(options) {
                Object.assign(messages, options.messages);
                Object.assign(settings, options);
            },
            resizeMap() {
                const parentArea = this.parent().first();
                this.height(parentArea.height());
                this.width(parentArea.width());
            },
            setMapData(data, trackingId, mapPositionParam) {
                setMapData(data, trackingId, mapPositionParam);
            },
            refreshMapData(data, trackingId, _mapPositionParam) {
                setMapData(data, trackingId, null);
            },
            showMapPositionButton(_page) { },
            showRightareaButton() { },
            hideRightareaButton() { },
            resetMap() { },
            closeInfoboxVehicleAll() {
                popups.value = [];
            },
            closeInfoboxDestinationAll() { },
            openInfoboxVehicle(_type, rowId) {
                var _a;
                openPopup((_a = vehicles.value) === null || _a === void 0 ? void 0 : _a[vehicleId(rowId)]);
            },
            closeInfoboxVehicle(_type, rowId) {
                closePopup(vehicleId(rowId));
            },
            openInfoboxDestination(_type, rowId) {
                var _a;
                openPopup((_a = destinations.value) === null || _a === void 0 ? void 0 : _a[destinationId(rowId)]);
            },
            closeInfoboxDestination(_type, rowId) {
                closePopup(destinationId(rowId));
            },
            setTrackingMode(_movementMapData, trackingId) {
                // 追尾モード
                setTrackingMode(trackingId);
            },
            isTrackingMode() {
                return Boolean(trackingVehicleId.value);
            },
            resetTrackingMode() {
                setTrackingMode(null);
            },
            setFilterModeVehicles(targetIds) {
                vehiclesFilterIds.value = targetIds.map((id) => vehicleId(id));
            },
            resetFilterModeVehicles() {
                vehiclesFilterIds.value = undefined;
            },
            setFilterModeDestinations(targetIds) {
                destinationsFilterIds.value = targetIds.map((id) => destinationId(id));
            },
            resetFilterModeDestinations() {
                destinationsFilterIds.value = undefined;
            },
            setLabelButton(flag) {
                showLabels.value = flag;
            },
            setEndedButton(flag) {
                showEnded.value = flag;
            },
            getCurrMapPosition() {
                return {
                    lat: mapCenter.value[1],
                    lon: mapCenter.value[0],
                    zoom: mapZoom.value,
                };
            },
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Map, {
                ref_key: "map",
                ref: map,
                "zoom-control": "left-top:1rem,5rem",
                "scale-line": "",
                "min-zoom": 6,
                center: mapCenter.value,
                "onUpdate:center": _cache[11] || (_cache[11] = ($event) => ((mapCenter).value = $event)),
                zoom: mapZoom.value,
                "onUpdate:zoom": _cache[12] || (_cache[12] = ($event) => ((mapZoom).value = $event)),
                onClick: _cache[13] || (_cache[13] = ($event) => (popups.value = []))
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).Markers, {
                        markers: markers.value,
                        onClick: (0, vue_2.withModifiers)(onMarkerClicked, ["stop"]),
                        annotations: vehicleAnnotations.value
                    }, null, 8, ["markers", "annotations"]),
                    (layout.value === 2 && trackingVehicle.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Pulse, {
                            key: 0,
                            center: trackingVehicle.value.coordinate
                        }, null, 8, ["center"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (showCluster.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Cluster, {
                            key: 1,
                            markers: vehiclesFiltered.value,
                            onClick: (0, vue_2.withModifiers)(onClusterClicked, ["stop"])
                        }, null, 8, ["markers"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Dropdown), {
                        active: clusterPopup.value,
                        "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((clusterPopup).value = $event)),
                        "popup-anchor": clusterPopupAnchor.value,
                        "no-trigger": ""
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownLabel), null, {
                                default: (0, vue_2.withCtx)(() => _cache[14] || (_cache[14] = [
                                    (0, vue_2.createTextVNode)("候補選択", -1)
                                ])),
                                _: 1,
                                __: [14]
                            }),
                            (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(clusterMarkers.value, (v) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                        key: v.id,
                                        onClick: ($event) => {
                                            clusterPopup.value = false;
                                            openPopup(v);
                                        }
                                    }, {
                                        default: (0, vue_2.withCtx)(() => {
                                            var _a, _b, _c, _d;
                                            return [
                                                ((_a = v.id) === null || _a === void 0 ? void 0 : _a.startsWith('vehicle:'))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).MarkerImage, {
                                                            icon: v === null || v === void 0 ? void 0 : v.icon
                                                        }, null, 8, ["icon"]),
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(v.data.vehicle_name) + " ", 1),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(v.data.vehicle_code), 1)
                                                        ])
                                                    ]))
                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                                        (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).MarkerImage, {
                                                            icon: v === null || v === void 0 ? void 0 : v.icon
                                                        }, null, 8, ["icon"]),
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(v.data.name) + " ", 1),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((_b = v.data) === null || _b === void 0 ? void 0 : _b.prefecture) + (0, vue_2.toDisplayString)((_c = v.data) === null || _c === void 0 ? void 0 : _c.municipality) + (0, vue_2.toDisplayString)((_d = v.data) === null || _d === void 0 ? void 0 : _d.address), 1)
                                                        ])
                                                    ]))
                                            ];
                                        }),
                                        _: 2
                                    }, 1032, ["onClick"]));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    }, 8, ["active", "popup-anchor"]),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(popups.value, (id) => {
                        var _a;
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Popup, {
                            key: id,
                            center: (_a = markers.value[id]) === null || _a === void 0 ? void 0 : _a.coordinate,
                            onClose: ($event) => (closePopup(id)),
                            style: { "width": "max-content", "max-height": "30vh" }
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (id.startsWith('vehicle:'))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BssMapVehicleInfobox_vue_1.default, {
                                        key: 0,
                                        data: markers.value[id].data,
                                        "movement-settings": mapData.value.movement_settings
                                    }, null, 8, ["data", "movement-settings"]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BssMapDestinationInfobox_vue_1.default, {
                                        key: 1,
                                        data: markers.value[id].data,
                                        "movement-settings": mapData.value.movement_settings
                                    }, null, 8, ["data", "movement-settings"]))
                            ]),
                            _: 2
                        }, 1032, ["center", "onClose"]));
                    }), 128)),
                    (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).SidePanel, {
                        show: showMenu.value,
                        side: "right",
                        style: { "width": "40vw", "background": "white", "overflow": "auto" }
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (showMenu.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.ResizeHandle), {
                                    key: 0,
                                    orientation: "vertical",
                                    "handle-size": "4px",
                                    style: { "background": "#ccc", "border": "1px solid #bbb" }
                                }))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.SidePanelContainer), null, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(LoadPage_vue_1.default, {
                                        url: props.url,
                                        query: query.value,
                                        onLoad: onload
                                    }, null, 8, ["url", "query"]),
                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.SidePanel), {
                                        show: layout.value === 1,
                                        side: "bottom",
                                        style: { "height": "300px" }
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (layout.value === 1)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.ResizeHandle), {
                                                    key: 0,
                                                    orientation: "horizontal",
                                                    "handle-size": "4px",
                                                    style: { "background": "#ccc", "border": "1px solid #bbb" }
                                                }))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).Map, {
                                                "zoom-control": "left-top:1rem",
                                                "scale-line": "",
                                                center: mapSubCenter.value,
                                                "onUpdate:center": _cache[1] || (_cache[1] = ($event) => ((mapSubCenter).value = $event)),
                                                zoom: mapSubZoom.value,
                                                "onUpdate:zoom": _cache[2] || (_cache[2] = ($event) => ((mapSubZoom).value = $event))
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (layout.value === 1 && trackingVehicle.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Pulse, {
                                                            key: 0,
                                                            center: trackingVehicle.value.coordinate
                                                        }, null, 8, ["center"]))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (layout.value === 1 && trackingVehicle.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Markers, {
                                                            key: 1,
                                                            markers: [trackingVehicle.value],
                                                            annotations: vehicleAnnotations.value
                                                        }, null, 8, ["markers", "annotations"]))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (layout.value === 1 && trackingVehicle.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, " 追尾中... "))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                                        (layout.value === 1 && trackingVehicle.value)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                                                key: 0,
                                                                onClick: clearTrackingMode,
                                                                type: "image",
                                                                id: "tracking_reset_button",
                                                                class: "tracking-reset-button",
                                                                src: settings.others.img_icon_back,
                                                                title: messages.tracking_reset_button
                                                            }, null, 8, _hoisted_8))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ])
                                                ]),
                                                _: 1
                                            }, 8, ["center", "zoom"])
                                        ]),
                                        _: 1
                                    }, 8, ["show"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["show"]),
                    (0, vue_2.createVNode)(BssMovementNaviationIcons_vue_1.default, {
                        modelValue: mode.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((mode).value = $event))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                class: (0, vue_2.normalizeClass)(["rounded-full the-map-pin-button", { pinned: mapPinned.value }]),
                                icon: "fa:map-pin",
                                "icon-size": "1.5rem",
                                onClick: _cache[3] || (_cache[3] = ($event) => (mapPinned.value = !mapPinned.value))
                            }, null, 8, ["class"]),
                            (layout.value === 2 && trackingVehicle.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, " 追尾中... "))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Toggle), {
                                position: "top",
                                modelValue: showCluster.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((showCluster).value = $event))
                            }, {
                                default: (0, vue_2.withCtx)(() => _cache[15] || (_cache[15] = [
                                    (0, vue_2.createTextVNode)("クラスタ表示", -1)
                                ])),
                                _: 1,
                                __: [15]
                            }, 8, ["modelValue"]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Toggle), {
                                position: "top",
                                modelValue: showLabels.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((showLabels).value = $event))
                            }, {
                                default: (0, vue_2.withCtx)(() => _cache[16] || (_cache[16] = [
                                    (0, vue_2.createTextVNode)("ラベル表示", -1)
                                ])),
                                _: 1,
                                __: [16]
                            }, 8, ["modelValue"]),
                            (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Toggle), {
                                position: "top",
                                modelValue: showEnded.value,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((showEnded).value = $event))
                            }, {
                                default: (0, vue_2.withCtx)(() => _cache[17] || (_cache[17] = [
                                    (0, vue_2.createTextVNode)("運行終了表示", -1)
                                ])),
                                _: 1,
                                __: [17]
                            }, 8, ["modelValue"])
                        ]),
                        (0, vue_2.createVNode)(ModalCreate_vue_1.default, {
                            url: "/movement/select_vehicle",
                            query: query.value,
                            action: "/movement/select_vehicle/save",
                            "form-id": "select_vehicle-modal"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                    icon: "fa:truck",
                                    "icon-position": "top"
                                }, {
                                    default: (0, vue_2.withCtx)(() => _cache[18] || (_cache[18] = [
                                        (0, vue_2.createTextVNode)("車両選択", -1)
                                    ])),
                                    _: 1,
                                    __: [18]
                                })
                            ]),
                            _: 1
                        }, 8, ["query"]),
                        (0, vue_2.createVNode)(BssMovementConfig_vue_1.default),
                        (0, vue_2.createVNode)(BssMovementLayoutChanger_vue_1.default, {
                            modelValue: layout.value,
                            "onUpdate:modelValue": [
                                _cache[8] || (_cache[8] = ($event) => ((layout).value = $event)),
                                _cache[9] || (_cache[9] = ($event) => (showMenu.value = true))
                            ],
                            list: [2, 1]
                        }, null, 8, ["modelValue"]),
                        (0, vue_2.createVNode)(BssMovementToggleListButton_vue_1.default, {
                            modelValue: showMenu.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((showMenu).value = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        (layout.value === 2 && trackingVehicle.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                key: 0,
                                onClick: clearTrackingMode,
                                type: "image",
                                id: "tracking_reset_button",
                                class: "tracking-reset-button",
                                src: settings.others.img_icon_back,
                                title: messages.tracking_reset_button
                            }, null, 8, _hoisted_13))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                _: 1
            }, 8, ["center", "zoom"]));
        };
    }
});
